<template>
  <div>
    <scholar-quiz v-if="$route.params.type == 'Quiz'" />
    <scholar-assessment v-if="$route.params.type == 'Assessment'" />
    <scholar-material v-if="$route.params.type == 'Materi'" />
    <scholar-attandence v-if="$route.params.type == 'Attendance'" />
    <scholar-assignment v-if="$route.params.type == 'Assignment'" />
    <scholar-group-project v-if="$route.params.type == 'GroupProject'" />
    <scholar-synchronous v-if="$route.params.type == 'Synchronous'" />
    <scholar-indie-project v-if="$route.params.type == 'IndividuProject'" />
    <div class="pa-3"></div>
  </div>
</template>

<script>
import ScholarAssessment from "./scholarAssessment.vue";
import ScholarAssignment from "./scholarAssignment.vue";
import ScholarAttandence from "./scholarAttandence.vue";
import ScholarGroupProject from "./scholarGroupProject.vue";
import ScholarIndieProject from "./scholarIndieProject.vue";
import ScholarMaterial from "./scholarMaterial.vue";
import ScholarQuiz from "./scholarQuiz.vue";
import ScholarSynchronous from "./scholarSynchronous.vue";

export default {
  components: {
    ScholarQuiz,
    ScholarAssessment,
    ScholarMaterial,
    ScholarAttandence,
    ScholarAssignment,
    ScholarGroupProject,
    ScholarSynchronous,
    ScholarIndieProject,
  },
  name: "viewModule",
  data() {
    return {};
  },

  mounted() {},
  methods: {},
};
</script>

<style scoped></style>
